
import React, { useState, useEffect } from 'react';
import { formatNumberWithCommas } from './utils/creditUtils';

interface CreditBalanceDisplayProps {
  credits: number;
}

export const CreditBalanceDisplay: React.FC<CreditBalanceDisplayProps> = ({ credits }) => {
  return (
    <div className="settings-card overflow-hidden relative">
      {/* Decorative background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -right-24 w-48 h-48 rounded-full bg-stewie-blue opacity-10 blur-3xl"></div>
        <div className="absolute -bottom-32 -left-12 w-64 h-64 rounded-full bg-stewie-accent opacity-10 blur-3xl"></div>
      </div>
      
      <div className="relative p-6">
        <h3 className="text-lg font-medium text-white mb-1">Current Balance</h3>
        
        <div className="flex flex-col md:flex-row md:items-end gap-2 md:gap-6">
          <div>
            <div className="flex items-baseline gap-1">
              <span className="text-4xl font-bold text-gradient">
                {formatNumberWithCommas(credits)}
              </span>
              <span className="text-xl text-stewie-gray">credits</span>
            </div>
            
            <div className="mt-1 text-stewie-gray text-sm">
              Available for trading operations
            </div>
          </div>
          
          <div className="bg-stewie-accent/10 border border-stewie-accent/20 rounded-lg px-4 py-2">
            <div className="text-stewie-accent text-sm font-medium">Tradeable AUM</div>
            <div className="text-white text-lg font-bold">
              ${formatNumberWithCommas(credits * 1000)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Also add a default export to maintain compatibility with both import styles
export default CreditBalanceDisplay;
